import {Component, Injector, OnInit} from "@angular/core";
import {ModalService} from "@app/presentation/services/modal/modal.service";
import {BehaviorSubject} from "rxjs";
import {ExitService} from "@app/presentation/services/exit.service";

export interface ConfirmationModalData {
    title: string;
    message: string;
    acceptButtonText: string;
    cancelButtonText: string;
}

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

    private readonly dataSubject = new BehaviorSubject<ConfirmationModalData|null>(null);
    protected readonly data$ = this.dataSubject.asObservable();

    constructor(
        private readonly injector: Injector,
    ) {}

    ngOnInit() {
        const data = ModalService.getModalData<ConfirmationModalData>(this.injector);
        if (data != null) {
            this.dataSubject.next(data);
        }
    }

    protected handleOnClickAcceptAction() {
        ExitService.exit(this.injector, true);
    }

    protected handleOnClickCancelAction() {
        ExitService.exit(this.injector, false);
    }

}